import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=98481872&scoped=true&"
import script from "./PaymentTable.vue?vue&type=script&lang=js&"
export * from "./PaymentTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTable.vue?vue&type=style&index=0&id=98481872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98481872",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VSpacer})
